export default "/static/dashboard/build/app/img/v2/f18a63c224967b6b4d0d66f6037da00c.png";